import React, { useState } from 'react';
import Header from '../components/Header';
import ContactFooter from '../components/ContactFooter';
import Button from '../components/Button';

const ContactUs = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = Object.fromEntries(new FormData(e.target).entries());

    const submissionData = {
      ...formData,
      category: 'Org Contact',
      company: formData.companyName,
      message: formData.message,
    };

    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbx4F7lIgfGh1UbmgJ-jk_XRJRk8_R1ZksspphxSWF5jJ3bJwuHnHybuPzMbHP7wNKdAPg/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(submissionData),
        }
      );

      setSubmitted(true);
      e.target.reset();
    } catch (error) {
      console.error('Error submitting contact form:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#000',
        color: '#fff',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <main
        style={{
          flex: 1,
          padding: '6rem 2rem 3rem',
          maxWidth: '700px',
          margin: '0 auto',
        }}
      >
        <h1 className="huge-title">Contact Us</h1>
        {!submitted && (
          <>
            <h2 className="subtitle">
              Please provide a detailed message so we can best serve you.
            </h2>
          </>
        )}

        {submitted ? (
          <p style={{ minHeight: '100px', color: '#4ade80', textAlign: 'center' }}>
            Your message has been received. We'll get back to you soon!
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
            }}
          >
            <input name="name" placeholder="Name*" required style={inputStyle} />
            <input name="email" type="email" placeholder="Email*" required style={inputStyle} />
            <input name="companyName" placeholder="Organization" style={inputStyle} />
            <textarea
              name="message"
              placeholder="Message*"
              rows={3}
              required
              style={{ ...inputStyle, resize: 'vertical', minHeight: '50px' }}
            />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {loading ? (
                <div className="loader" style={{ width: '24px', height: '24px', border: '3px solid #999', borderTop: '3px solid #fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              ) : (
                <Button type="submit" label="Send Message" />
              )}
            </div>
          </form>
        )}
      </main>
      <ContactFooter />
    </div>
  );
};

const inputStyle = {
  padding: '0.75rem',
  borderRadius: '0.5rem',
  border: '1px solid #333',
  fontSize: '1rem',
  backgroundColor: '#1a1a2e',
  color: '#fff',
  width: '80%',
  margin: '0 auto',
};

export default ContactUs;